import { ensureGuestToken, hasRecoverableGuestSession, GuestRecoveryUnavailableError } from "@/lib/guest-session"

async function verifyUserInCart() {
  const accountToken = await ensureGuestToken()
  if (!accountToken) {
    if (hasRecoverableGuestSession()) throw new GuestRecoveryUnavailableError()
    window.location.href = "/cart/profile-data"
    throw new Error("No guest session")
  }
  return { accountToken }
}

export default verifyUserInCart
